import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateDocumentTypeModel,
  DeleteDocumentTypeModel,
  SearchDocumentTypeModel,
} from '../../../models/document-type.model'
import { SearchTaxDocumentTypeModel } from '../../../models/tax-document-type.model'

@Injectable({
  providedIn: 'root',
})
export class ContentTypeService {
  private baseUrl = environment.baseUrl
  private resourceType: string = 'tipoConteudo'

  constructor(private httpClient: HttpClient) {}

  public createContentType(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/create`,
      model,
    )
  }

  public editContentType(
    model: any,
    // model: EditDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/update`,
      model,
    )
  }

  public deleteContentType(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/delete/${id}`
    )
  }

  public listPagedContentType(
    page?: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/list`,
    )
  }

  public listContentType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/list`,
    )
  }

  public getDocumentTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${id}`,
    )
  }

  public searchPagedDocumentType(
    page: number,
    rows: number = 15,
    model: SearchDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
